import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';

//utils
import queries from '../../../utils/queries'
import SeguroPermite from '../../../components/funcionales/seguropermite'

// "use strict";

//Documentos

  const DetDocum = ({elemento}) => {
    return(
      <tr className=''>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoProducto}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoOrden?elemento.tipoOrden:''}</td>
        {/* <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numProducto}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento._id}</td> */}
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrProducto}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codigo?elemento.codigo:''}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nuevaDescripcion}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante?elemento.descrLubricante:'NINGUNO'}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.marca}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrUnidad}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.costo?elemento.costo:0}</td> 
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.precio}</td> 
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.precioDolar}</td> 
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.vigenteHasta?elemento.vigenteHasta:''}</td> 
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.porcIVA}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.porcImpto}</td>
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estado}</td>
      </tr>
    )
  };

const ListaDocum = ({list, tipoCargue}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetDocum elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class CargPro2 extends React.Component {
  state={listDocum: [], checked: true, checked2: false, permiteUpdate: true, confirmaAct: false, open: false, errors: []
}

  handleChange = async (ev) => {
    const updState = (listDocum) => {
      this.setState({listDocum, errors: []})
    };
    if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"||ev.target.name==="calcularPrecio"){
      let checkTieneEncab = document.getElementById("checkTieneEncab").checked
      let calcularPrecio = document.getElementById("calcularPrecio").checked2
      let fileInput = document.getElementById("csv")
      if(fileInput.files.length>0){
        let archcsv = ""
        let reader = new FileReader();
        reader.onload = function () {
          archcsv = reader.result

        let archivo = archcsv.toString()

        let lines = archivo.split(/\n/)
        let numDoc = 0, linea = 0, listDocum = []
          lines.forEach(line => {
            if(line&&(numDoc>0||(numDoc===0&&!checkTieneEncab))){
              linea += 1
              let campos = line.split(";")
              let _id = campos[0]
              let numProducto = campos[1]?campos[1]:0
              let tipoProducto = campos[2].replace(/^\s+|\s+$/g, '')
              let tipoOrden = campos[3].replace(/^\s+|\s+$/g, '')
              let descrProducto = campos[4]
              let codigo = campos[5]
              let descrLubricante = campos[6]
              let marca = campos[7].replace(/^\s+|\s+$/g, '')
              let costo = campos[8].replace(/\./g,'')
              costo = costo.replace(/\,/g,'.')
              costo = parseFloat(costo)
              let monedaCosto = campos[9]
              let precio = campos[10].replace(/\./g,'')
              precio = precio.replace(/\,/g,'.')
              precio = parseFloat(precio)
              let precioDolar = campos[11].replace(/\./g,'')
              precioDolar = precioDolar.replace(/\,/g,'.')
              precioDolar = parseFloat(precioDolar)
              let vigenteHasta = campos[12]
              let campoAgno = ''
              let campoMes = ''
              let campoDia= ''
              if(vigenteHasta){
                campoAgno = vigenteHasta.substring(0, 4)
                campoMes = vigenteHasta.substring(5, 7)
                campoDia = vigenteHasta.substring(8, 10)
                if(campoDia!==null && campoDia!=='' && campoMes!==null && campoMes!=='' && campoAgno!==null && campoAgno!==''){
                  let mes = parseInt(campoMes, 10)
                  if(mes < 10){ 
                    campoMes='0' + mes
                  }else{
                    campoMes = mes
                  }
                  let dia = parseInt(campoDia, 10)
                  if(dia < 10){ 
                    campoDia='0' + dia
                  }else{
                    campoDia = dia
                  }
                  vigenteHasta = campoAgno + '-' + campoMes + '-' + campoDia
                }
              }
              let descrUnidad = campos[13].replace(/^\s+|\s+$/g, '')
              let porcIVA = campos[14]
              let porcImpto = campos[15]
              let estado = campos[16].replace(/(\r\n|\n|\r)/gm,'')
              if(estado==='Activo' || estado==="Activo" || estado==='activo' || estado==='"Activo"' || estado==='"activo"'){
                estado='Activo'
              }else{
                estado='Inactivo'
              }
              let comisionRango1 = campos[17].replace(/\./g,'');
              comisionRango1 = comisionRango1.replace(/\,/g,'.');
              comisionRango1 = parseFloat(comisionRango1)
              let comisionRango2 = campos[18].replace(/\./g,'');
              comisionRango2 = comisionRango2.replace(/\,/g,'.');
              comisionRango2 = parseFloat(comisionRango2)
              let comisionRango3 = campos[19].replace(/\./g,'');
              comisionRango3 = comisionRango3.replace(/\,/g,'.');
              comisionRango3 = parseFloat(comisionRango3)
              let comisionExt = campos[20].replace(/\./g,'');
              comisionExt = comisionExt.replace(/\,/g,'.');
              comisionExt = parseFloat(comisionExt)
              let margen = campos[21]?campos[21]:0;
              let nuevaDescripcion = campos[22].replace(/(\r\n|\n|\r)/gm, '')
              if(descrProducto){
                listDocum.push({_id, numProducto, tipoProducto, tipoOrden, descrProducto, codigo, descrLubricante, marca, 
                  costo, monedaCosto, precio, precioDolar, vigenteHasta, descrUnidad, porcIVA, porcImpto, estado, 
                  comisionRango1, comisionRango2, comisionRango3, comisionExt, margen, nuevaDescripcion})
              }
            }
            numDoc += 1
          })
          console.log(listDocum)
          updState(listDocum)
        }  
        reader.readAsBinaryString(fileInput.files[0]);
        this.setState({checked: checkTieneEncab, checked2: calcularPrecio})
      }else{
        this.setState({listDocum: [], errors: []})
      }
    }
  }

  handleSubmit = async (ev, listDocum)=>{
    const a251025 = this.props.autorizacUA.findIndex( autorizac => autorizac === "251025" );
    let calcularPrecio = document.getElementById("calcularPrecio").checked2
    
    document.body.style.cursor = 'wait'
      let errors = []
      if(listDocum.length===0){
        errors.push({path: "Cargue", message: "No hay información"});
      }

      this.setState({errors})
      if(errors.length===0){
        listDocum.forEach(async (elemento, i) => {
          let _id = elemento._id
          let tipoProducto = elemento.tipoProducto, tipoOrden = elemento.tipoOrden 
          let descrProductoAnt = elemento.descrProducto, descrProducto = elemento.nuevaDescripcion
          let descrLubricante = elemento.descrLubricante?elemento.descrLubricante:"NINGUNO"
          let marca = elemento.marca?elemento.marca:"" 
          let monedaCosto = elemento.monedaCosto?elemento.monedaCosto:"Pesos" 
          let precio = elemento.precio?elemento.precio:0 
          let costo = elemento.costo?elemento.costo:0 
          let precioDolar = elemento.precioDolar?elemento.precioDolar:0
          let margen = elemento.margen?elemento.margen:0 
          let vigenteHasta = elemento.vigenteHasta?elemento.vigenteHasta:""
          let descrUnidad = elemento.descrUnidad?elemento.descrUnidad:""
          let porcIVA = elemento.porcIVA?elemento.porcIVA:0, porcImpto = elemento.porcImpto?elemento.porcImpto:0
          let estado = elemento.estado?elemento.estado:'Activo'
          if(!tipoProducto){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato del tipo de producto`});
          }
          if(!tipoOrden){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato del tipo de orden`});
          }
          if(!descrProducto){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la descripción del producto`});
          }
          if(!marca){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la marca`});
          }
          if((precio===null || precio==='' || precio<0) && calcularPrecio===false){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato del precio`});
          }
          if(calcularPrecio===true && tipoProducto==='Producto'){
            if(!monedaCosto){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la moneda del costo`});
            }else{
              if(monedaCosto==="Pesos" || monedaCosto==="Dolares" || monedaCosto==="Euros"){
                if(costo===null || costo==='' || costo<=0){
                  errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato del costo`});
                }
              }else{
                errors.push({path: "Cargue", message: `Línea: ${elemento.numProducto} ${monedaCosto} La moneda del costo solo puede ser Pesos, Dolares o Euros`});
              }
            }
          }else{
            if(monedaCosto==="Pesos" || monedaCosto==="Dolares" || monedaCosto==="Euros"){
            }else{
              errors.push({path: "Cargue", message: `Línea: ${elemento.numProducto} ${monedaCosto} La moneda del costo solo puede ser Pesos, Dolares o Euros`});
            }
            if(costo===null || costo==='' || costo<0){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} Dato del costo no valido`});
            }
          }
          if(!vigenteHasta){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la fecha de vigencia del precio`});
          }
          if(!descrUnidad){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la unidad`});
          }          
          if(descrProductoAnt){
            // let indexEq = productos.findIndex( producto => producto.descrProducto===descrProductoAnt)
            // if(indexEq===-1){
            //   errors.push({path: "Cargue", message: `Línea: ${i + 1} PRODUCTO NO EXISTE: ${descrProductoAnt}`});
            // }

            // let indexUni = unidades.findIndex( unidadPro => unidadPro.descrUnidad===descrUnidad )

            // if(indexUni===-1){
            //   errors.push({path: i + " Cargue", message: `Línea: ${i + 1} => La unidad ${descrUnidad} no ha sido creada`});
            // }
            if(descrLubricante!=="NINGUNO"){
              // let indexLub = lubricantes.findIndex( lubricantePro => lubricantePro.descrLubricante===descrLubricante)

              // if(indexLub===-1){
              //   errors.push({path: i + " Cargue", message: `Línea: ${i + 1} => El lubricante ${descrLubricante} no ha sido creado`});
              // }
            }
            // if(estado==="Activo"){ 
            // }else{
            //   if(estado==="Inactivo"){
            //   }else{
            //     errors.push({path: i + " Cargue", message: `Línea: ${i + 1} => El estado del producto solo puede ser Activo o Inactivo ${estado}`});
            //   }
            // }
          }
        })
        if(errors.length>0){
          this.setState({errors})
        }else{
          let minimoDolar=0, maximoDolar=0
          if(this.props.getParametro.getParametro){
            minimoDolar = this.props.getParametro.getParametro.minimoDolar
            maximoDolar = this.props.getParametro.getParametro.maximoDolar
          }
          listDocum.forEach(async (elemento, i) => {
            let argsUpd = {}
            let precio=elemento.precio, precioDolar=elemento.precioDolar
            if(a251025!==-1){
              if(elemento.tipoProducto==='Producto' && calcularPrecio===true){
                if(elemento.monedaCosto==='Pesos'){
                  precio=parseInt(elemento.costo/(1-(elemento.margen/100)))
                  precioDolar=parseFloat((elemento.costo/(1-(elemento.margen/100)))/minimoDolar).toFixed(2)
                }else{
                  precio=parseInt(elemento.costo*maximoDolar)
                  precioDolar=parseFloat(elemento.costo/(1-(elemento.margen/100))).toFixed(2)
                }
              }
              argsUpd = {
                _id: elemento._id,
                numProducto: elemento.numProducto?parseInt(elemento.numProducto):0,
                tipoProducto: elemento.tipoProducto, 
                tipoOrden: elemento.tipoOrden, 
                codigo: elemento.codigo?elemento.codigo:"", 
                descrProducto: elemento.nuevaDescripcion,
                descrLubricante: elemento.descrLubricante,
                descrProductoAnt: elemento.descrProducto,
                marca: elemento.marca?elemento.marca:"", 
                precio: precio,
                costo: elemento.costo?elemento.costo:0,
                monedaCosto: elemento.monedaCosto?elemento.monedaCosto:"",
                precioDolar: precioDolar,
                comisionRango1: elemento.comisionRango1?elemento.comisionRango1:0,
                comisionRango2: elemento.comisionRango2?elemento.comisionRango2:0,
                comisionRango3: elemento.comisionRango3?elemento.comisionRango3:0,
                comisionExt: elemento.comisionExt?elemento.comisionExt:0,
                vigenteHasta: elemento.vigenteHasta,
                descrUnidad: elemento.descrUnidad,
                porcIVA: elemento.porcIVA?elemento.porcIVA:0,
                margen: elemento.margen?elemento.margen:0,
                porcImpto: elemento.porcImpto?elemento.porcImpto:0,
                modArch1: "N",
                modArch2: "N",
                estado: elemento.estado
              }
              console.log(argsUpd)
            }else{
              argsUpd = {
                _id: elemento._id,
                numProducto: elemento.numProducto?parseInt(elemento.numProducto):0,
                // numProducto: 0,
                tipoProducto: elemento.tipoProducto, 
                tipoOrden: elemento.tipoOrden, 
                codigo: elemento.codigo?elemento.codigo:"", 
                descrProducto: elemento.nuevaDescripcion,
                descrLubricante: elemento.descrLubricante,
                descrProductoAnt: elemento.descrProducto,
                marca: elemento.marca?elemento.marca:"", 
                vigenteHasta: elemento.vigenteHasta,
                descrUnidad: elemento.descrUnidad,
                porcIVA: elemento.porcIVA?elemento.porcIVA:0,
                porcImpto: elemento.porcImpto?elemento.porcImpto:0,
                modArch1: "N",
                modArch2: "N"
              }
              console.log(argsUpd)
            }
            const response = await this.props.editProducto({
              variables: argsUpd
            });
            const {errors, success} = response.data.editProducto;
            if (!success){
              console.log(errors)
              this.setState({errorAdd: errors})
            }else{
              console.log("PASOOO")
            }
            
            // this.setState({listDocum: []})
            
          })
        }

        if(errors.length===0){
          alert("!! Carga exitosa !!")
        }
      }
    document.body.style.cursor = 'default'
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  // async componentDidUpdate(prevProps){

  // }

  render(){
    const {listDocum, checked, checked2, permiteUpdate, confirmaAct, open, errors} = this.state;
    let mensaje = "PROCESAR ARCHIVO"
    let imgIcon = "images/archivo_32.png"
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let tit1 = "Edición masiva de productos"
    let tit2 = "Procesar archivo de productos"

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large plus yellow icon"></i>
            {tit1}
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listDocum):()=>{}}>
              <div>
                <div className="ui one column stackable grid">
                    <div className="row container">
                        <div className="column" style={{width: '100%'}}>
                          <h1 style={{color: '#2C7744'}}>{tit2}</h1>
                        </div>
                    </div>
                </div>
                <hr></hr>
                <hr></hr>
                <br/>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Seleccionar archivo CSV...&nbsp;&nbsp;
                      </label>

                      <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                  name="checkTieneEncab" checked={checked} onChange={this.handleChange}/>
                          &nbsp;&nbsp;Tiene encabezados en la primera fila
                        </p>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="calcularPrecio"
                                  name="checkTieneEncab" checked={checked2} onChange={this.handleChange}/>
                          &nbsp;&nbsp;Calcular precios de venta de productos según costo
                        </p>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <br/>
                <hr></hr>
                <hr></hr>
                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Total documentos:&nbsp;
                  {listDocum.length}
                </p>

                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                    </div>
                  </div>
                </div>
                <hr></hr>

                {
                    errors.length?<Message negative header="Los siguientes errores:"
                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
                <div style={{height: '40em', overflow: 'auto'}}>
                  <table id="tablaDocum" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo de Producto</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo de orden</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Descripción actual</th>
                        {/* <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>ID</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Producto</th> */}
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Código</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Nueva descripción</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Lubricante asociado</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Marca</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Unidad</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Costo</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Precio und en $</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Precio und en $US</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Vigencia de precio</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>% IVA</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>% ITBMS</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estado</th>
                      </tr>
                    </thead>
                    <ListaDocum list={listDocum} />
                  </table>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    )    
  }
}

export default compose(
  // graphql(queries.query.allProducto, {name:'allProducto'}),
  graphql(queries.query.allUnidad, {name:'allUnidad'}),
  graphql(queries.mutation.editProducto, {name:'editProducto'}),
  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),
  
  graphql(queries.mutation.fecha, {name:'fecha'}),
)(CargPro2)
